// extracted by mini-css-extract-plugin
module.exports = {"redirect":"CheckoutForm_redirect__1lo_C"};